<div class="extra-narrow-content">
  <mat-card>
    <mat-card-content>
      <h1>Settings</h1>
      <h3>Security</h3>
      <p>
        <a routerLink="/change-password" class="text-link">Change password</a>
      </p>

      <app-change-theme></app-change-theme>

      <app-toggle-tracking></app-toggle-tracking>
    </mat-card-content>
  </mat-card>
</div>
